export default __webpack_public_path__ + "static/media/Mulugeta-Kassahun.6c80912e.png";